<app-header />

<mat-card>
  <mat-card-header>
    <mat-card-title>CPR List</mat-card-title>
    <div class="buttons">
      <button mat-flat-button routerLink="create" [checkPermission]="['cpr', 'edit']">
        Create
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <app-cprs-table tableAlias="cprs" />
  </mat-card-content>
</mat-card>
